import { SIFTED_WP_SITE } from "lib/constants";

export function buildCanonicalUrl(path: string): string {
  return `${SIFTED_WP_SITE}${path}`;
}
